// **********************************************************
//  Site footer
// **********************************************************
/* eslint-disable */
$(function () {
  // Toogle footer nav in mobile
  $('.site-footer__nav-title').on('click', function () {
    if (windowWidth() < 767) {
      $(this).parents('.site-footer__nav').toggleClass('is-open').find('ul').slideToggle();
    }
  });
});
/* eslint-enable */
